const fieldValidation = {
  required: '{{fieldName}}は必須です',
  pattern: '{{fieldName}}が無効です',
  min: '{{fieldName}}は{{value}}以上である必要があります',
  max: '{{fieldName}}は{{value}}以下である必要があります',
};

export default fieldValidation;
